import { configureStore as createStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist'
import encryptedStorage from '../util/encryptedStorage';
import rootReducer from "./rootReducer";
import createDebounceModule from "redux-debounced";
const createDebounce = createDebounceModule.default || createDebounceModule;

let persistConfig = {
  key: "root",
  storage: encryptedStorage,
  // Don't persist any slices - app data now lives in Dexie
  // Legacy data remains in encryptedStorage for migration utility to read
  blacklist: ['multiSelect', 'ethereal', 'app']
}

let persistedReducer = persistReducer(persistConfig, rootReducer);

export const configureStore = () => {
  let store = createStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          // Ignore redux-persist and ethereal layout actions
          ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
          ignoredPaths: ['ethereal.juryPoolBounds'],
        },
      }).concat(createDebounce()),
  });
  let persistor = persistStore(store);

  return {
    store,
    persistor
  };
}

const configured = configureStore();

export const store = configured.store;
export const persistor = configured.persistor;


